export default function StringToFloatParser(value: string) {
    return parseFloat(value.replace(/[^0-9.-]+/g, ""));
}
